/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Search from 'apollo-react-icons/Search';
import classNames from 'classnames';
import React, { useCallback, useContext, useState } from 'react';

import RegulatoryTermsZoomDialog from '../../../components/RegulatoryTermsZoomDialog';
import { ZOOM_STYLES } from '../../../constants/CommonStylesConstants';
import { useFormSelector } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';
import { getUITA } from '../../../utils/commonUtils';
import { isNilOrEmpty } from '../../../utils/ramdaUtils';
import { SubGridContext } from '../../context';
import { getDataByController } from '../../selectors/runtime.selectors';
import {
  getMEDDRASearchByItems,
  getSearchOptionItems,
} from '../../utils/controls/ssRegulatoryTermsZoom.utils';

const useStyles = makeStyles(ZOOM_STYLES);

const SSRegulatoryTermsMEDDRA = ({
  className,
  isEditor,
  isInTable,
  regulatoryTerms,
  uniqueIdentifier,
  index,
  termHierarchy,
  actions,
  textBoxPropsJson = '{}',
  isOnline,
  id,
}) => {
  const { isMobileDevice } = useWindowDimensions();
  const classes = useStyles();
  const translateString = useTranslation();
  const [open, setOpen] = useState(false);
  const inSubGrid = useContext(SubGridContext);
  const inSubGridOrMobile = inSubGrid || isMobileDevice;

  const { entityName, fieldName } = JSON.parse(textBoxPropsJson);
  const defaultValue = useFormSelector(getDataByController, { entityName, fieldName, index });
  const symptomCode = useFormSelector(getDataByController, {
    entityName,
    fieldName: 'SYMPTOM_CODE',
    index,
  });

  const hasDefaultValue = !(isNilOrEmpty(symptomCode) && isNilOrEmpty(defaultValue));
  const searchByItems = getMEDDRASearchByItems(hasDefaultValue);
  const searchOptionItems = getSearchOptionItems(translateString);

  const setDialogClose = useCallback(() => setOpen(false), []);

  const handleSelect = useCallback(
    ({ selectedPath = [] }) => {
      const fieldNames = ['OTHER_CODE_1', 'OTHER_NAME_1', 'OTHER_CODE_4', 'OTHER_NAME_4'];
      const data = {};

      const pt = selectedPath.find(({ TermHierarchy }) => TermHierarchy === 'PT');
      const soc = selectedPath.find(({ TermHierarchy }) => TermHierarchy === 'SOC');
      const llt = selectedPath.find(({ TermHierarchy }) => TermHierarchy === 'LLT');

      data.OTHER_CODE_1 = pt.Code;
      data.OTHER_NAME_1 = pt.Name;
      data.OTHER_CODE_4 = soc.Code;
      data.OTHER_NAME_4 = soc.Name;

      if (llt) {
        fieldNames.push('OTHER_CODE_5');
        fieldNames.push('OTHER_NAME_5');
        data.OTHER_CODE_5 = llt.Code;
        data.OTHER_NAME_5 = llt.Name;
      }

      const changesToApply = fieldNames.map((fName) => ({
        value: data[fName],
        entityName,
        fieldName: fName,
        index,
      }));

      actions.bulkUpdateControlValues(changesToApply);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [actions, `${index}`]
  );

  return (
    <>
      <span
        className={classNames(
          classes.root,
          className,
          isInTable ? classes.inTable : '',
          inSubGridOrMobile && !isInTable ? classes.inSubGridOrMobile : '',
          isEditor ? classes.zoomEditMode : ''
        )}
        onClick={() => !isEditor && isOnline && setOpen(true)}
        ui-ta={getUITA('FormCtrl', 'SSZoom', 'SSRegulatoryTermsMEDDRA', uniqueIdentifier)}
        data-ss-id={id}
      >
        <div>
          <Search className={classes.searchIcon} color={isOnline ? 'primary' : 'disabled'} />
        </div>
      </span>
      <RegulatoryTermsZoomDialog
        open={open}
        type="MEDDRA"
        defaultSearchText={defaultValue || symptomCode || ''}
        searchByItems={searchByItems}
        searchOptionItems={searchOptionItems}
        termHierarchy={termHierarchy}
        regulatoryTerms={regulatoryTerms}
        onSelect={handleSelect}
        onClose={setDialogClose}
      />
    </>
  );
};

export default SSRegulatoryTermsMEDDRA;
